/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAttendanceCountTodayGet$Plain$Params {
  cycleId?: string;
}

export function apiAttendanceCountTodayGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAttendanceCountTodayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceCountTodayGet$Plain.PATH, 'get');
  if (params) {
    rb.query('cycleId', params.cycleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

apiAttendanceCountTodayGet$Plain.PATH = '/api/attendance/count-today';
